


































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "cardTypeInfo",
  components: {},
})
export default class cardTypeInfo extends Vue {
  //props
  @Prop()
  Xxx?: String;

  //data

  //computed

  //beforeCreated
  beforeCreated() {}

  //created
  created() {}

  //beforeMount
  beforeMount() {}

  //mounted
  mounted() {}

  //beforeUpdate
  beforeUpdate() {}

  //updated
  updated() {}

  //activated
  activated() {}

  //deactivated
  deactivated() {}

  //beforeDestroy
  beforeDestroy() {}

  //destroyed
  destroyed() {}

  //methods

  //watch
  @Watch("XXX", { deep: true })
  handleWatch(newVal: any, oldVal: any) {
    console.log(newVal, oldVal);
  }
}
